import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { PermitDialogComponent } from './components/permit-dialog/permit-dialog.component';
import { PermitMapViewComponent } from "./components/permit-map-view/permit-map-view.component";
import { PtwAllTablesRecordsComponent } from './components/ptw-all-tables-records/ptw-all-tables-records.component';
import { PtwDashboardComponent } from "./components/ptw-dashboard/ptw-dashboard.component";
import { PtwGasTestRecordTableComponent } from "./components/ptw-gasTestRecord-table/ptw-gas-test-record-table/ptw-gas-test-record-table.component";
import { RaisePermitComponent } from './components/raise-permit/raise-permit.component';
import { PermitToWorkRoutingModule } from "./permittowork-routing.module";
import { PermitToWorkConstantsService } from "./services/permittowork-constants.service";
import { PermitToWorkService } from "./services/permittowork.service";

@NgModule({
  imports: [
    CommonModule,
    PermitToWorkRoutingModule,
    SharedModule,
  ],
  declarations: [
    PtwDashboardComponent,
    RaisePermitComponent,
    PermitDialogComponent,
    PtwGasTestRecordTableComponent,
    PermitMapViewComponent,
    PtwAllTablesRecordsComponent
  ],
  providers: [
    PermitToWorkService,
    PermitToWorkConstantsService,
  ],
})
export class PermitToWorkModule { }
